"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditsText = exports.Credits = void 0;

var _react = _interopRequireDefault(require("react"));

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Credits = function Credits(_ref) {
  var creditsTexts = _ref.creditsTexts;
  return _react.default.createElement(_styles.Container, null, _react.default.createElement(_bricksTheme.default, null), creditsTexts.map(function (creditsText) {
    return _react.default.createElement(CreditsText, {
      key: creditsText.id,
      category: creditsText.category,
      name: creditsText.name,
      title: creditsText.title,
      link: creditsText.link
    });
  }));
};

exports.Credits = Credits;

var CreditsText = function CreditsText(_ref2) {
  var category = _ref2.category,
      title = _ref2.title,
      name = _ref2.name,
      link = _ref2.link;
  return _react.default.createElement(_react.default.Fragment, null, !!category && _react.default.createElement(_styles.Category, null, category), _react.default.createElement(_styles.Content, null, _react.default.createElement(_styles.Title, null, title, ": "), !link && _react.default.createElement(_styles.Name, null, name) || _react.default.createElement(_styles.Link, {
    href: link,
    target: "_blank",
    rel: "noreferrer"
  }, _react.default.createElement(_styles.Name, null, name))));
};

exports.CreditsText = CreditsText;